import * as React from 'react';
import { withTranslation } from '@i18n';
import {
  StyledAdditionalBenefitsWrapper,
  StyledCard,
  StyledImageWrapper,
  StyledGridUnit,
  StyledGrid,
  StyledDescription
} from './styles';

const card = [
  'Online Assistance',
  'Visa Assistance',
  'Airport Transfer',
  'Cab service for daily commute from hotel to hospital',
  'Get a 75 USD cash voucher for medicine',
  'Free Room Upgrade',
  '24/7 Patient support',
  'Priority appointment',
  'Local Number Provided'
];

const AdditionalBenefits = () => (
  <StyledAdditionalBenefitsWrapper>
    <StyledGrid>
      {card.map((description, index) => (
        <StyledGridUnit size={{ mobile: 1 / 2, desktop: 1 / 3 }}>
          <StyledCard>
            <StyledImageWrapper>
              <img
                src={`/static/images/svg/ProfilePackage/AdditionalBenefitsIcon/additionalBenefitsIcon${index}.svg`}
                alt={description}
              />
            </StyledImageWrapper>
            <StyledDescription>{description}</StyledDescription>
          </StyledCard>
        </StyledGridUnit>
      ))}
    </StyledGrid>
  </StyledAdditionalBenefitsWrapper>
);

export default withTranslation('ProfilePackages')(AdditionalBenefits);
